import originalClassNames from "classnames";
import type { Argument } from "classnames";
import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  prefix: "wb-",
});

export const classNames = (...args: Argument[]) =>
  twMerge(originalClassNames(args));
